import type { ConsultantKpiPeriod } from "@asap/shared/schemas/team-member-data";
import { formatDateForDB } from "@asap/shared/utils/date";
import { useApi } from "~/composables/useApi";

export const useConsultantKpiApi = () => {
  const { invoke } = useApi();

  const getConsultantKpi = async (params: {
    teamMemberId: string;
    period: ConsultantKpiPeriod;
    referenceDate: Date;
  }) => {
    const response = await invoke({
      path: "team-member-data/consultant-kpi",
      method: "GET",
      query: {
        teamMemberId: params.teamMemberId,
        period: params.period,
        referenceDate: formatDateForDB(params.referenceDate),
      },
    });
    if (!response.success) throw new Error(response.error.message);
    return response.data;
  };

  return { getConsultantKpi };
};
